import React from 'react'
import { Helmet } from 'react-helmet-async'
import { MediaAuditLogsLayout } from '../../layouts'

const MediaAuditLogsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>DAM audit logs</title>
      <meta name="description" content="DAM audit logs page" />
    </Helmet>
    <MediaAuditLogsLayout />
  </React.Fragment>
)

export default MediaAuditLogsPage
